import axios from 'axios';
import { BASE_URL } from '../Utlils';

export const getSurveyAllocationSuppliers = async ({ surveyId, orgId }) => {
  try {
    const request = await axios.post(
      `${BASE_URL}/${surveyId}/allocation/available-suppliers`,
      { orgId },
    );
    const json = request.data;
    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};

export const createSurveyAllocation = async (data) => {
  try {
    const { surveyId } = data;
    if (!surveyId) {
      throw new Error('Survey ID is required');
    }
    const request = await axios.post(
      `${BASE_URL}/${surveyId}/allocation/create-survey-allocation`,
      data,
    );
    const json = request.data;
    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};

export const submitEditAllocation = async (data) => {
  try {
    const { surveyId, allocationId } = data;
    if (!surveyId) {
      throw new Error('Survey ID is required');
    }
    if (!allocationId) {
      throw new Error('Allocation ID is required');
    }
    const request = await axios.patch(
      `${BASE_URL}/${surveyId}/allocation/update-survey-allocation/${allocationId}`,
      data,
    );
    const json = request.data;

    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};

const fetchAllSurveyAllocations = async (data) => {
  try {
    const { surveyId, orgId } = data;
    if (!surveyId || !orgId) {
      throw new Error('Survey ID and Organisation ID are required');
    }
    const request = await axios.post(
      `${BASE_URL}/${surveyId}/allocation/all-allocations`,
      data,
    );
    const json = request.data;
    if (!json?.success) {
      return {
        success: false,
        data: null,
        error: json?.message ?? 'Something went wrong',
      };
    }
    return {
      success: true,
      data: json,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};

// get all survey allocations (swr call):
export const getAllSurveyAllocations = async (data) => {
  const result = await fetchAllSurveyAllocations(data);
  if (!result.success) throw new Error(result?.error);
  return result.data;
};

export const submitToggleAllocationStatus = async (data) => {
  try {
    const { surveyId, allocationId } = data;
    if (!surveyId) {
      throw new Error('Survey ID is required');
    }
    if (!allocationId) {
      throw new Error('Allocation ID is required');
    }
    const request = await axios.patch(
      `${BASE_URL}/${surveyId}/allocation/toggle-status/${allocationId}`,
      data,
    );
    const json = request.data;

    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};

export const submitToggleMiratsAllocationStatus = async (data) => {
  try {
    const { surveyId } = data;
    if (!surveyId) {
      throw new Error('Survey ID is required');
    }

    const request = await axios.patch(
      `${BASE_URL}/${surveyId}/allocation/toggle-mirats-allocation`,
    );
    const json = request.data;

    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};

export const submitToggleMiratsRewardsOnly = async (data) => {
  try {
    const { surveyId } = data;
    if (!surveyId) {
      throw new Error('Survey ID is required');
    }

    const request = await axios.patch(
      `${BASE_URL}/${surveyId}/allocation/toggle-mirats-rewards-only`,
    );
    const json = request.data;

    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error:
        error?.response?.data?.message ??
        error?.message ??
        'Network error. Please check your connection.',
    };
  }
};

export const surveySupplierAllocationList = async (data) => {
  try {
    const { surveyId, orgId } = data;
    if (!surveyId || !orgId) {
      throw new Error('Survey ID and Organisation ID are required');
    }
    const request = await axios.post(
      `${BASE_URL}/${surveyId}/allocation/allocated-supplier-list`,
      { orgId },
    );
    const json = request.data;
    if (!json?.success) {
      throw new Error(json?.message ?? 'Something went wrong');
    }
    return json;
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error?.message ?? 'Network error. Please check your connection.',
    };
  }
};
